import { type FC } from 'react';
import { useFragment, graphql } from 'react-relay';
import { NavTopHeader } from './NavTopHeader.tsx';
import { NavHelp } from './NavHelp.tsx';
import classNames from 'classnames';
import dibsCss from 'dibs-css';

import { type NavHeader_viewer$key } from './__generated__/NavHeader_viewer.graphql.ts';
import { type NavHeader_links$key } from './__generated__/NavHeader_links.graphql.ts';

type Props = {
    viewer: NavHeader_viewer$key;
    links: NavHeader_links$key;
    activeLink: string;
};

const viewerFragment = graphql`
    fragment NavHeader_viewer on Viewer {
        seller(sellerId: $sellerPk) @include(if: $hasSellerPk) {
            ...NavHelp_seller
        }
    }
`;

const linksFragment = graphql`
    fragment NavHeader_links on NavBarLinks {
        navItems {
            href
            title
            hideSideNavTitle
            ... on NavBarList {
                items {
                    href
                    title
                    hideSideNavTitle
                }
            }
        }
    }
`;
export const NavHeader: FC<Props> = ({ viewer: viewerRef, links: linksRef, activeLink }) => {
    const viewer = useFragment(viewerFragment, viewerRef);
    const links = useFragment(linksFragment, linksRef);
    const { navItems } = links;

    let header = null;

    const activeItem = navItems?.reduce<{
        href?: string | null;
        title?: string | null;
        hideSideNavTitle?: boolean | null;
    } | null>((active, navItem) => {
        if (navItem?.href === activeLink) {
            return navItem;
        }
        let activeSubItem;
        if (navItem?.items) {
            activeSubItem = navItem?.items?.find(item => item?.href === activeLink) || null;
            return activeSubItem ?? active;
        }
        return active;
    }, null);

    header = activeItem?.title;

    if (!activeItem || activeItem.hideSideNavTitle) {
        return null;
    }

    return (
        <NavTopHeader>
            <div className={classNames(dibsCss.flex1, dibsCss.sassyFontHeader)}>{header}</div>
            <NavHelp seller={viewer.seller} />
        </NavTopHeader>
    );
};
